import React from 'react';
import { Box, Button, Typography} from '@mui/material';

const OfflineScreen = ({text,buttonCallMe,colors,callbackClickAction}) => {
  return (
    <>
        <Box sx={{ flexGrow: 1, padding: 2, overflowY: 'auto' }}>
            <Typography fontSize={25} sx={{ textAlign:'center'}}>
                {text}
            </Typography>
        </Box>

        <Box sx={{display:'flex',justifyContent:'center',padding:5}}>
            <Button sx={{backgroundColor:colors.secondary.backgroundColor,alignSelf:'flex-start', marginLeft:2,fontSize:'1.1vh'}} variant="contained" onClick={callbackClickAction}>
                {buttonCallMe}
            </Button>
        </Box>
    </>
  );
};

export default OfflineScreen;